<template>
  <div class="company-search overlay--dropdown" role="search">
    <OverlayContainer class="company-search__components" :event-bus="eventBus">
      <div class="textsearch" search-request="">
        <label for="textSearch_input" class="sr-only">Søg på forhandler</label>
        <div class="input input--search">
          <input
            title="Søg bl.a. på navn, mærke, bynavn"
            id="textSearch_input"
            type="text"
            placeholder="Søg bl.a. på navn, mærke, bynavn..."
            class="input--search"
            v-model="searchString"
            @keyup.enter="handleSearch"
            @focus="closeOverlay"
            ref="textSearchInput"
          />
          <ClearInput
            :value="searchString"
            :event-bus="eventBus"
            :search-icon="true"
          />
        </div>
      </div>
      <component
        v-for="(component, index) in ui.components"
        v-bind="component.props"
        :key="index"
        :is="component.type"
        :id="component.id"
        :event-bus="eventBus"
        :product-type-id="searchRequest[0]"
        :search-request="searchRequest"
        :clear-search-activated="clearSearchActivated"
        :search-types="component.searchTypes"
      ></component>
      <button class="button button--highlight" @click="handleSearch">
        søg
      </button>
    </OverlayContainer>

    <teleport to="#companySearchResultTeleport">
      <CompanySearchResults
        :search-header-prop="searchHeader"
        :search-result-prop="searchResult"
        :search-type-prop="searchType"
      >
      </CompanySearchResults>
    </teleport>
  </div>
</template>

<script>
import { app } from '@/main'
import { nextTick } from 'vue'

import { LogSearchCompanies } from '@/events'

import Overlay from '@shared/Overlay/Overlay.vue'
import OverlayProductType from '@shared/OverlayProductType/OverlayProductType.vue'
import OverlayContainer from '@shared/Overlay/OverlayContainer.vue'
import OverlayEventHandlerMixin from '@shared/Overlay/overlay-event-handler-mixin.vue'
import Arrow from '@shared/Arrow/Arrow.vue'
import ClearInput from '@shared/ClearInput/ClearInput.vue'
import CompanySearchResults from '../CompanySearchResults/CompanySearchResults.vue'

import SearchComponentsMixin from '@search/search-components-mixin.vue'
import SearchMixin from '@components/Search/search-mixin.vue'

import ClearSearch from '@search/ClearSearch/ClearSearch.vue'

export default {
  mixins: [SearchComponentsMixin, OverlayEventHandlerMixin, SearchMixin],
  props: {
    uiProp: { default: null, type: Object },
  },
  data() {
    return {
      searchResult: [],
      searchHeader: '',
      searchString: '',
      searchType: '',
      clearSearchActivated: false,
      countAds: false,
    }
  },
  components: {
    OverlayContainer,
    Overlay,
    OverlayProductType,
    ClearSearch,
    Arrow,
    ClearInput,
    CompanySearchResults,
  },
  created() {
    this.ui = this.uiProp

    if (this.eventBus == null) return

    this.eventBus.on('clear-input-string', this.clearSearchString)
  },
  mounted() {
    this.getFromState()
  },
  methods: {
    saveInState() {
      window.history.replaceState(
        JSON.parse(
          JSON.stringify({
            searchResult: this.searchResult,
            searchHeader: this.searchHeader,
            searchString: this.searchString,
            searchType: this.searchType,
          })
        ),
        '',
        null
      )
    },
    getFromState() {
      if (window.history.state === null) return

      const searchHeader = window.history.state.searchHeader
      const searchResult = window.history.state.searchResult
      const searchString = window.history.state.searchString
      const searchType = window.history.state.searchType

      nextTick(() => {
        this.searchHeader = searchHeader
        this.searchResult = searchResult
        this.searchString = searchString
        this.searchType = searchType
      })
    },
    getSearchRequestObject() {
      const searchRequestObj = {}
      searchRequestObj.MakeIdList = []
      searchRequestObj.SearchString = this.searchString

      this.searchRequest.forEach(item => {
        if (item.type === 'MakeId') {
          searchRequestObj.MakeIdList.push(item.value)
        }
      })

      return searchRequestObj
    },
    closeOverlay() {
      if (app.history.getStackSize != 0) {
        app.history.pop()
      }
    },
    clearSearchString() {
      this.searchString = ''

      this.$refs.textSearchInput.focus()
    },
    handleSearch() {
      this.closeOverlay()

      app.axios
        .post('/Api/Company/Search', this.getSearchRequestObject())
        .then(resp => {
          this.searchResult = resp.data.companyList
          this.searchHeader = resp.data.headerText
          this.searchType = resp.data.typeText
          if (resp.data.subText) {
            this.searchHeader += ' - ' + resp.data.subText
          }
          LogSearchCompanies()

          nextTick(() => {
            this.saveInState()
          })
        })
    },
  },
}
</script>

<style lang="scss">
@import 'CompanySearch.scss';
</style>
